import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { ApsService } from "src/app/services";

@Component({
  selector: "app-new-payment-method-dialog",
  templateUrl: "./new-payment-method-dialog.component.html",
  styleUrls: ["./new-payment-method-dialog.component.scss"]
})
export class NewPaymentMethodDialogComponent
{

  public showAddCard: boolean = false;
  public showAddBank: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<NewPaymentMethodDialogComponent>,
    public apsService: ApsService
  ) { }

  handleAddClicked(value: string): void
  {
    this.dialogRef.close(value);
  }
}
